export interface ManifiestoEntry {
  id: string
  slug: string
  title: string
  subtitle: string
  category: "technology" | "business" | "research" | "platform"
  categoryLabel: string
  description: string
  readTime: string
  version: string
  lastUpdated: string
  icon: "cpu" | "briefcase" | "compass" | "lightbulb" | "bot" | "database" | "shield" | "chart"
  type?: "manifiesto" | "platform" | "use-case"
  status?: "active" | "coming-soon"
}

export const manifiestoEntries: ManifiestoEntry[] = [
  // Core Manifiestos
  {
    id: "holistika",
    slug: "holistika",
    title: "HOLISTIKA",
    subtitle: "A Framework for Business Logic and Growth",
    category: "business",
    categoryLabel: "Business Manifiesto",
    description: "The core philosophy and operational methodology of Holistika: applying logical frameworks to foster business efficiency, scalability, and intelligence-backed decision making.",
    readTime: "9 min read",
    version: "2.9",
    lastUpdated: "2026",
    icon: "briefcase",
    type: "manifiesto",
    status: "active"
  },
  {
    id: "madeira",
    slug: "madeira",
    title: "MADEIRA",
    subtitle: "The Agentic Knowledge Operating System",
    category: "technology",
    categoryLabel: "Technology Manifiesto",
    description: "Holistika's standpoint on using Artificial and Natural Intelligence together with business engineering and foresight. The epistemology of corporate intelligence.",
    readTime: "8 min read",
    version: "3.0",
    lastUpdated: "2026",
    icon: "cpu",
    type: "manifiesto",
    status: "active"
  },
  // Platform Use Cases
  {
    id: "madeira-agent",
    slug: "madeira-agent",
    title: "MADEIRA Agent",
    subtitle: "Multi-Agent Coordination System",
    category: "platform",
    categoryLabel: "Use Case Documentation",
    description: "The five-agent coordinated model: Madeira (Interface), Orchestrator (Coordinator), Architect (Planner), Executor (Builder), and Verifier (Quality Gate). Human-on-the-loop autonomous execution.",
    readTime: "8 min read",
    version: "0.6.0",
    lastUpdated: "2026",
    icon: "bot",
    type: "use-case",
    status: "active"
  },
  {
    id: "kirbe",
    slug: "kirbe",
    title: "KiRBe",
    subtitle: "Enterprise Knowledge Management Platform",
    category: "platform",
    categoryLabel: "Use Case Documentation",
    description: "Hybrid search combining keyword and semantic matching, enterprise-grade access controls, usage metering, and compliance-ready audit logging. The Intelligence Layer for semantic knowledge retrieval.",
    readTime: "7 min read",
    version: "1.2",
    lastUpdated: "2026",
    icon: "database",
    type: "use-case",
    status: "active"
  },
  {
    id: "envoy",
    slug: "envoy",
    title: "ENVOY",
    subtitle: "Integration & Channel Adapter Layer",
    category: "platform",
    categoryLabel: "Use Case Documentation",
    description: "Multi-channel integration layer connecting MADEIRA agents to external systems: Telegram, Slack, WhatsApp, and A2UI Canvas. The bridge between intelligence and action.",
    readTime: "5 min read",
    version: "2.1",
    lastUpdated: "2026",
    icon: "bot",
    type: "use-case",
    status: "active"
  },
  // Coming Soon Use Cases
  {
    id: "inframonitor",
    slug: "inframonitor",
    title: "InfraMonitor",
    subtitle: "Security & Audit Intelligence",
    category: "platform",
    categoryLabel: "Use Case Documentation",
    description: "Real-time security monitoring, compliance audit trails, and infrastructure observability. SOC2/GDPR-ready logging with intelligent anomaly detection.",
    readTime: "5 min read",
    version: "0.1",
    lastUpdated: "2026",
    icon: "shield",
    type: "use-case",
    status: "coming-soon"
  },
  {
    id: "financial-analyst",
    slug: "financial-analyst",
    title: "Financial Analyst",
    subtitle: "Real-Time Financial Dashboard",
    category: "platform",
    categoryLabel: "Use Case Documentation",
    description: "AI-powered financial analysis with real-time KPI extraction, trend detection, and predictive insights. Transform financial data into actionable intelligence.",
    readTime: "5 min read",
    version: "0.1",
    lastUpdated: "2026",
    icon: "chart",
    type: "use-case",
    status: "coming-soon"
  }
]

export const categoryColors = {
  technology: {
    bg: "bg-teal-600/10",
    border: "border-teal-600/30",
    text: "text-teal-500",
    dot: "bg-teal-500"
  },
  business: {
    bg: "bg-amber-600/10",
    border: "border-amber-600/30",
    text: "text-amber-500",
    dot: "bg-amber-500"
  },
  research: {
    bg: "bg-indigo-600/10",
    border: "border-indigo-600/30",
    text: "text-indigo-400",
    dot: "bg-indigo-400"
  },
  platform: {
    bg: "bg-slate-600/10",
    border: "border-slate-500/30",
    text: "text-slate-400",
    dot: "bg-slate-400"
  }
}
